import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_1321_93547)" }, [
      _createElementVNode("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M10.285 24v-9.017A13.474 13.474 0 0 1 24 1.714a13.474 13.474 0 0 1 13.714 13.269V24m-6.857 18a6.857 6.857 0 0 0 6.857-6.857v-7.715M30.857 42a4.286 4.286 0 0 1-4.286 4.285h-5.143a4.286 4.286 0 1 1 0-8.57h5.143A4.286 4.286 0 0 1 30.857 42M5.142 18.857h3.429a1.714 1.714 0 0 1 1.714 1.714v10.286a1.714 1.714 0 0 1-1.714 1.714H5.142a3.43 3.43 0 0 1-3.428-3.428v-6.858a3.43 3.43 0 0 1 3.428-3.428M42.857 32.57h-3.429a1.714 1.714 0 0 1-1.714-1.714V20.57a1.714 1.714 0 0 1 1.714-1.714h3.429a3.43 3.43 0 0 1 3.428 3.428v6.858a3.43 3.43 0 0 1-3.428 3.428"
      })
    ], -1)
  ])))
}
export default { render: render }